import React, { memo } from 'react'
import ControlledCheckbox from 'transfix-form/components/ControlledCheckbox'
import Typography from 'transfix-ui/core/Typography'
import { IEquipmentAttributeTypes } from 'types/graphqlTypes'
import { useCreateShipmentFormContext } from '../../../context'

export interface ILoadUnloadFormSectionProps {}

const LoadUnloadFormSection = memo<ILoadUnloadFormSectionProps>(() => {
  /**
   * Form Context
   */
  const { control } = useCreateShipmentFormContext()

  return (
    <div>
      <Typography variant='subtitle1'>Load/Unload Equipment</Typography>
      <div>
        <ControlledCheckbox
          control={control}
          name={`equipmentAttributes.${IEquipmentAttributeTypes.pallet_jack}`}
          CheckboxProps={{
            label: 'Pallet Jack',
            dataTest: 'pallet-jack-field',
          }}
        />
      </div>
      <div>
        <ControlledCheckbox
          control={control}
          name={`equipmentAttributes.${IEquipmentAttributeTypes.lift_gate}`}
          CheckboxProps={{
            label: 'Lift Gate',
            dataTest: 'lift-gate-field',
          }}
        />
      </div>
    </div>
  )
})

export default LoadUnloadFormSection
